"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var MenuButton = function (props) {
    var classes = ["editor-toolbar__button"];
    if (props.customClass) {
        classes.push(props.customClass);
    }
    if (props.isDestructive) {
        classes.push("editor-toolbar__button--destructive");
    }
    var wrapperClass = classes.join(" ");
    return (react_1.default.createElement("div", { className: wrapperClass, onMouseDown: !props.disabled ? props.onMouseDown : undefined, "data-active": props.isActive, "data-disabled": props.disabled }, props.icon));
};
var WidgetMenuButton = function (props) {
    var button = (react_1.default.createElement(MenuButton, { icon: props.icon, onMouseDown: props.onMouseDown, customClass: props.customClass, isActive: props.isActive, isDestructive: props.isDestructive, disabled: props.disabled }));
    if ((props.tooltipMessage == undefined || props.tooltipMessage.length == 0) && !props.tooltip) {
        return button;
    }
    else if (props.tooltip) {
        return (react_1.default.createElement(kaleidoscope_1.Tooltip, __assign({ wrapTarget: true }, props.tooltip), button));
    }
    else {
        return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: props.tooltipMessage }, button));
    }
};
exports.default = WidgetMenuButton;
